module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "list",
    class: _vm.classes
  }, [_c('ul', {
    staticClass: "list__group"
  }, _vm._l((_vm.posts), function(post) {
    return (_vm.posts) ? _c('li', {
      staticClass: "list__item"
    }, [_c('router-link', {
      staticClass: "list__post",
      attrs: {
        "to": ("/blogue/" + (post.path))
      }
    }, [_c('div', {
      staticClass: "list__content"
    }, [_c('h5', {
      staticClass: "list__title"
    }, [_vm._v(_vm._s(post.title || ((post.fulltitle) ? post.fulltitle[0].content : ' ')))])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": ("/blogue/categorie/" + (post.category))
      }
    }, [_c('icon', {
      staticClass: "list__icon",
      class: ("list__icon--" + (post.category)),
      attrs: {
        "id": post.category
      }
    })], 1)], 1)], 1) : _vm._e()
  })), _vm._v(" "), _c('nav', {
    staticClass: "list__nav"
  }, [_c('button', {
    staticClass: "paging paging--prev",
    attrs: {
      "data-disabled": !_vm.prevPage
    },
    on: {
      "click": function($event) {
        _vm.page--
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "paging",
    attrs: {
      "data-disabled": !_vm.nextPage
    },
    on: {
      "click": function($event) {
        _vm.page++
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-98a31494!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/blog/PostList.vue
// module id = 648
// module chunks = 1